import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers'
import type { Device, GenericHandlerValues, MoteStatus } from '../../../models'

export interface MoteStatusQueryData {
  moteStatus: MoteStatus
  device: Device
}

export type UseMoteStatusQueryValues = GenericHandlerValues<
  MoteStatusQueryData,
  'POST'
>

export interface UseMoteStatusQueryOptions {
  moteId: string
  refetchInterval?: number
  abortable?: boolean
}

export const useMoteStatusQuery = (
  options: UseMoteStatusQueryOptions
): UseMoteStatusQueryValues => {
  const values = useGenericRequestHandler({
    abortable: options.abortable,
    route: `v1/m/status/${options.moteId}`,
    enabled: Boolean(options.moteId),
    refetchInterval: options.refetchInterval,
    method: 'POST',
    options: { timeout: 25000 }
  })
  //@ts-expect-error
  return withEngagingURL(values)
}
